module.exports = __webpack_public_path__ + "img/ideen_Arrow_grey_back.b6745898.png";